export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const REFRESH_CURRENT_USER = "REFRESH_CURRENT_USER";

export const SET_LOCATION = "SET_LOCATION";
